<template>
  <div>
    <button
      class="button is-info is-light is-small is-outline is-rounded"
      v-if="hasMatchingAspNetUser"
      @click="loadUpdateNote(note, unitNoteID)"
    >
      Edit</button
    >&nbsp;
    <button
      class="button is-info is-light is-small is-outline is-rounded"
      v-if="hasMatchingAspNetUser"
      @click="confirmUnitNoteDelete(note, unitNoteID)"
    >
      Delete
    </button>
  </div>
</template>

<script>
export default {
  props: {
    hasMatchingAspNetUser: Boolean,
    loadUpdateNote: Function,
    confirmUnitNoteDelete: Function,
    note: String,
    unitNoteID: [Number, String]
  }
}
</script>
